module.exports = __webpack_public_path__ + "static/media/Diesel_Generator.a0870409.png";